Controller = require 'controller'
Dates = require 'lib/dates'
OrganizationBoardsForMemberView = require 'views/organization/organization-boards-for-member-view'
RemoveGuestFromTeamBoardsView = require 'views/organization/remove-guest-from-team-boards'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class MemberOrgActivityView extends View
  viewTitleKey: 'team boards'

  viewTitleArguments: ->
    memberName: @model.get('fullName')

  initialize: ->
    @org = @options.org

  events:
    'click .js-view-org-boards-for-member': 'viewBoards'
    'click .js-view-member-org-cards': 'viewCards'
    'click .js-remove-guest-from-team-boards': 'removeGuestFromTeamBoards'

  render: ->
    data = @model.toJSON()

    data.isPremium = @org.isPremium()

    data.boards = @org.boardList.models
      .filter (board) =>
        _.contains(board.memberList.models, @model) && board.isOpen()
      .map (board) =>
        b = board.toJSON()
        b.memberType = l(['member types', board.getMemberType(@model)])
        b.url = board.getUrl()
        return b

    data.canRemoveFromAllTeamBoards = @org.owned() && !@org.isMember(@model) && data.boards.length > 0 && data.isPremium
    data.teamBoardCount = data.boards.length
    data.hasBoards = data.teamBoardCount > 0

    if @org.isFeatureEnabled('orgCards')
      data.orgCardsUrl = Controller.getOrganizationMemberCardsUrl(
        @org.get('name'),
        data.username
      )

    @$el.html(
      templates.fill(
        'org_member_activity',
        data
      )
    )

    Dates.update(@el)

    @

  viewCards: ->
    track("Organization View", "Members Page", "Activity - View Org Cards")

  viewBoards: (e) ->
    Util.stop(e)
    track("Organization View", "Members Page", "Activity - View Boards")

    PopOver.pushView
      view: new OrganizationBoardsForMemberView({
        @model,
        parent: @org,
        @modelCache }
      )

    return

  removeGuestFromTeamBoards: (e) ->
    Util.stop(e)
    track("Organization View", "Members Page", "Activity - Remove From All Team Boards")

    teamBoardCount = parseInt(@$(e.target).closest('b').attr('data-teamboardcount'), 10)

    PopOver.pushView
      view: new RemoveGuestFromTeamBoardsView({
        @model,
        parent: @org,
        @modelCache,
        teamBoardCount }
      )

    return



// WEBPACK FOOTER //
// ./app/scripts/views/organization/member-org-activity-view.coffee